import { FormEvent } from "react"

interface Props {
  disabledInput: boolean;
  userInput: string;
  setValueInput: (e: string) => void;
  onSubmit: () => void;
}

export const ContentInputIA = ({ onSubmit, userInput, setValueInput, disabledInput }: Props) => {

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  }

  return (
    <form className="ai-chat__in" onSubmit={handleSubmit}>
      <div className="ai-chat__in-area">
        <textarea name="Rate" value={userInput} onChange={(e) => setValueInput(e.target.value)} id="txtAreaRate" className="txt-area" cols={30} rows={5} placeholder="Pregúntame lo que necesites"></textarea>
        <div className="ai-chat__in-actions">
          <button type="submit" disabled={disabledInput} id="enviar-btn" className="btn btn-rounded btn-rounded-transparent aside-btn tippy" data-tippy-content="Enviar" aria-label="Enviar">
            <span className="btn__icon"><i className="icon icon-send"></i></span>
          </button>
        </div>
      </div>
    </form>
  )
}